import Breadcrumb from "@/components/feature/Breadcrumb";
import Accordion from "@/components/base/Accordion";
import { faqs, site } from "@/mocks/site";
import { useSeo } from "@/hooks/useSeo";

export default function FaqPage() {
  useSeo({
    title: "常见问题 | 导航爆料",
    description:
      "关于导航爆料的分类方式、内容来源、数据口径与信息真实性等常见问题的解答。有问题尽管来问。",
    keywords: "导航爆料,常见问题,帮助中心,信息真实性",
    path: "/faq",
    jsonLd: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    }),
  });

  return (
    <>
      <Breadcrumb crumbs={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />
      <section className="mx-auto w-full max-w-4xl px-4 py-8 md:px-6 md:py-12">
        <div className="mb-8 text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-semibold text-primary-700">
            <i className="ri-question-line"></i>帮助中心
          </span>
          <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            常见问题
          </h1>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-foreground-600 md:text-base">
            关于分类方式、内容来源与信息真实性的问题，都可以在这里找到答案。
          </p>
        </div>

        <Accordion items={faqs} />

        <div className="mt-10 flex flex-col items-center gap-3 rounded-lg border border-background-200/70 bg-background-100 p-6 text-center">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-lg text-primary-700">
            <i className="ri-customer-service-2-line"></i>
          </span>
          <p className="text-sm text-foreground-700">没找到你想要的答案？</p>
          <a
            href={`mailto:${site.email}`}
            className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-send-line"></i>
            联系我们
          </a>
        </div>
      </section>
    </>
  );
}